

(()=>{
  function init(root){
    const sections=[...(root.matches?.('[data-random-featured]')?[root]:[]),...root.querySelectorAll('[data-random-featured]')];
    sections.forEach(section=>{
      if(section.dataset.randomReady)return;
      const grid=section.querySelector('[data-random-grid]');if(!grid)return;
      const seen=new Set();const cards=[...grid.querySelectorAll('[data-random-card]')].filter(card=>{if(seen.has(card.dataset.productId))return false;seen.add(card.dataset.productId);return true});
      if(section.dataset.randomize==='true')for(let i=cards.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[cards[i],cards[j]]=[cards[j],cards[i]];}
      const selected=cards.slice(0,3);selected.forEach((card,i)=>{card.hidden=false;card.classList.toggle('eu-featured-product--main',i===0)});
      grid.replaceChildren(...selected);section.dataset.randomReady='true';section.dataset.poolCount=String(cards.length);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});else init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();

